module.exports = __webpack_public_path__ + "static/media/twelve-apostles.a4e1464f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/twelve-apostles.jpg
// module id = 153
// module chunks = 0